import React from 'react';
import './OnboardingDivider.css';

// Where a redo starts in the onboarding transcript. The line is a stored bot
// message ("Updated questions · 8 October 2026") so the staff transcript view
// reads it as text; ChatAgentPanel draws every message whose id is a redo's
// divider_message_id with this instead of a bot bubble.
function OnboardingDivider({ text }) {
  return (
    <div className="onboarding-divider" role="separator" aria-label={text}>
      <span className="onboarding-divider-text">{text}</span>
    </div>
  );
}

export default OnboardingDivider;
